import React from 'react';
import { ChildAccountsController } from 'src/components/enterprise/Parents/Admin/ChildAccountsController/ChildAccountsController';
import { useCanAccessParentAdminFlows } from './hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const ParentChildAccounts: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <ChildAccountsController />;
};
